import React from 'react';
import DialogContentText from '@mui/material/DialogContentText';
import Button from '@mui/material/Button';

import MinCustomDialog from '../Dialogs/MinCustomDialog';

const DialogDelete = ({ open, length, updateData, deleteAll }) => (
  <MinCustomDialog
    open={open}
    maxWidth={'xs'}
    title="Supprimer les Prosp"
    actions={[
      <Button key={1} onClick={() =>
        updateData('openDelete', false)} color="primary"> Annuler </Button>,
      <Button key={2} onClick={deleteAll}
        color="primary" autoFocus>Confirmer</Button>
    ]}
    middle children={<DialogContentText>
      {`Etes vous sur de vouloir supprimer ${length} prosp ?`}
    </DialogContentText>} />
);

export default (DialogDelete);
